<a mat-icon-button matTooltip="App Launcher" [matMenuTriggerFor]="appLauncher">
  <mat-icon class="header-icon">apps</mat-icon>
</a>

<mat-menu #appLauncher class="app-launcher" fxLayout="row wrap">
  <ng-container *ngFor="let app of apps">
    <a mat-menu-item *ngIf="app.badge !== 'soon' && app.visible" [routerLink]="[app.url]" [class.deprecated]="app.badge == 'deprecated'">
      <div class="icon-holder">
        <mat-icon *ngIf="app.iconClass == 'material-icons'"
                  [class.disabled]="app.disabled"
                  [style.color]="app.color"
                  [matBadge]="app.notificationBadge"
                  matBadgeOverlap="true"
                  matBadgeColor="warn"
                  [matBadgeHidden]="!app.notificationBadge">
          {{app.iconClassCode}}
        </mat-icon>

        <mat-icon *ngIf="app.iconClass != 'material-icons'"
                  fontSet="fa" [fontIcon]="app.iconClass.replace('fa ', '')"
                  [class.disabled]="app.disabled"
                  [style.color]="app.color">
        </mat-icon>
      </div>
      {{app.title}}
    </a>
  </ng-container>
</mat-menu>
